import { Component, computed, EventEmitter, Inject, inject, input, LOCALE_ID, Output, signal } from '@angular/core';
import { MatDialog } from '@iota/iota-ui-components';
import {
    DialogConfigureRegistrationProductComponent,
    DialogConfigureRegistrationProductData
} from 'src/app/shared/dialogs/dialog-configure-registration-product/dialog-configure-registration-product.component';
import { CompanyProductSelectionWithProduct } from 'src/app/store/entity-models';
import { getLanguageCodeFromLocaleOrDefault, isDiscontinued } from 'src/app/shared/utils';
import { buildBackgroundImageUrl, buildLabels, isMockBasketProduct } from './registration-period-product-card.mapper';

@Component({
    standalone: false,
    selector: 'app-registration-period-product-card',
    templateUrl: './registration-period-product-card.component.html',
    styleUrls: ['./registration-period-product-card.component.scss']
})
export class RegistrationPeriodProductCardComponent {
    private readonly dialog = inject(MatDialog);

    readonly productSelection = input<CompanyProductSelectionWithProduct>();
    readonly editMode = input(false);
    readonly markedForDelete = input(false);
    readonly markedForAdd = input(false);

    @Output() markForDelete = new EventEmitter<string>();
    @Output() undoDelete = new EventEmitter<string>();

    readonly isMockBasketProduct = computed(() => isMockBasketProduct(this.productSelection()));
    readonly isDiscontinuedProduct = computed(() => isDiscontinued(this.productSelection()));
    readonly backgroundImageUrl = computed(() => buildBackgroundImageUrl(this.productSelection()));
    readonly labels = computed(() => buildLabels(this.productSelection(), this.language));

    readonly hovering = signal(false);
    readonly showEditModeButton = computed(() => this.hovering() && this.editMode());

    private readonly language: string;

    constructor(@Inject(LOCALE_ID) locale: string) {
        this.language = getLanguageCodeFromLocaleOrDefault(locale);
    }

    handleClick() {
        const selection = this.productSelection();

        if (!this.editMode()) {
            const data: DialogConfigureRegistrationProductData = {
                companyProductSelectionId: selection?.companyProductSelectionId,
                productId: selection?.infinkonProductId
            };

            this.dialog.open(DialogConfigureRegistrationProductComponent, { data });
            return;
        }

        if (this.markedForDelete()) {
            this.undoDelete.emit(selection?.companyProductSelectionId);
            return;
        }

        this.markForDelete.emit(selection?.companyProductSelectionId ?? selection?.infinkonProductId);
    }

    updateHover(hovering: boolean) {
        this.hovering.set(hovering);
    }
}
